import React from 'react';
import { allow } from '../classes/allow';
import cloneArray from './clone.array';
import { isAnObject } from './is.an.object';

export default function cloneObject(object: any = {}) {
    allow.anObject(object);
    let clonedObject: any = {};
    Object.keys(object).forEach(key => {
        const currentValue = object[key];
        if (React.isValidElement(currentValue))
            clonedObject[key] = currentValue;
        else if (isAnObject(currentValue))
            clonedObject[key] = cloneObject(currentValue);
        else if (Array.isArray(currentValue))
            clonedObject[key] = cloneArray(currentValue);
        else
            clonedObject[key] = currentValue;
    });
    return clonedObject;
}